import React, { useMemo } from 'react';
import { ExperienceSuccess, type ExperienceAttributes } from '@atlassian/jira-experience-tracker';
import { createCommonAttributes } from '../../../common/utils';

type Props = {
	experience: string;
	attributes?: ExperienceAttributes;
};

export const SoftwareExperienceSuccess = ({ experience, attributes }: Props) => {
	const experienceAttributes = useMemo(() => createCommonAttributes(attributes), [attributes]);

	return <ExperienceSuccess experience={experience} attributes={experienceAttributes} />;
};
